// UTM Tracking Utility for capturing and storing ad/campaign parameters

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
const STORAGE_KEY = 'pathbuddy_utm_data';

/**
 * Capture UTM parameters from URL and persist them in localStorage.
 * Should be called on application / landing page mount.
 */
export const captureUTMParameters = () => {
  if (typeof window === 'undefined') return;

  try {
    const searchParams = new URLSearchParams(window.location.search);
    const utmData = {};
    let hasUTM = false;

    UTM_KEYS.forEach(key => {
      const val = searchParams.get(key);
      if (val) {
        utmData[key] = val;
        hasUTM = true;
      }
    });

    if (hasUTM) {
      // Add timestamp
      utmData.captured_at = new Date().toISOString();
      
      // Store in localStorage so it persists across sessions
      localStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));
      
      // Store in sessionStorage as fallback
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));
    }
  } catch (error) {
    console.error('Error capturing UTM parameters:', error);
  }
};

/**
 * Retrieve persisted UTM parameters.
 * @returns {Object|null}
 */
export const getStoredUTMParameters = () => {
  if (typeof window === 'undefined') return null;

  try {
    const stored = localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Error retrieving UTM parameters:', error);
    return null;
  }
};

/**
 * Clear stored UTM parameters.
 */
export const clearStoredUTMParameters = () => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing UTM parameters:', error);
  }
};
